
import { defineComponent } from 'vue';
import '../../../../../../public/home_page/css/style.css';
import '../../../../../../public/home_page/css/reset.css';

export default defineComponent({
  components: {},
  setup: () => {
    return {};
  },
});
